<template>
  <v-dialog v-model="visible" persistent max-width="1200px">
    <v-card>
      <v-card-title class="text-uppercase">
        {{
          `REGISTRO PRESUPUESTARIO DE ${tipo}${tipo == 'gasto' ? ' E INVERSIONES' : ''} DE LA GESTIÓN ${
            gestion?.numero
          }`
        }}
      </v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col cols="12" md="12" class="pa-2 pb-0">
            <v-btn
              v-if="
                permisoEnSede &&
                (permisosPresupuestos1 || permisosPresupuestos2) &&
                !permisosPresupuestos3 &&
                gestion?.numero == new Date().getFullYear()
              "
              small
              color="primary"
              class="mr-2"
              @click="
                $refs.modalFormPresupuestoGestionMesRef.abrir(accionesPresupuestoGestion.REGISTRAR, [], presupuesto.id)
              "
              title="Registrar">
              <v-icon>mdi-plus</v-icon>
            </v-btn>

            <v-btn
              v-if="
                permisoEnSede &&
                (permisosPresupuestos1 || permisosPresupuestos2) &&
                !permisosPresupuestos3 &&
                gestion?.numero == new Date().getFullYear()
              "
              small
              class="mr-2"
              :disabled="deshabilitadoBotonEditar"
              @click="
                $refs.modalFormPresupuestoGestionMesRef.abrir(accionesPresupuestoGestion.EDITAR, item, presupuesto.id)
              "
              title="Editar">
              <v-icon>mdi-pencil</v-icon>

              Editar
            </v-btn>

            <v-btn
              v-if="permisosPresupuestos2 && !permisosPresupuestos3"
              small
              class="mr-2"
              :disabled="deshabilitadoBotonVerificar"
              @click="
                $refs.modalFormPresupuestoGestionMesRef.abrir(
                  accionesPresupuestoGestion.VERIFICAR,
                  item,
                  presupuesto.id,
                )
              "
              title="Aprobar">
              <v-icon>mdi-file-check</v-icon>

              Aprobar
            </v-btn>

            <v-btn
              small
              class="mr-2"
              :disabled="item == null"
              @click="
                $refs.modalFormPresupuestoGestionMesRef.abrir(accionesPresupuestoGestion.VER, item, presupuesto.id)
              "
              title="Ver">
              <v-icon>mdi-eye</v-icon>

              Ver
            </v-btn>

            <v-btn small class="mr-2" @click="listar" title="Recargar">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-col>

          <v-col cols="12" class="pa-2 pb-0">
            <ListadoPresupuestoGestion ref="listadoRef" :items="items" :cargando="cargando" @selectItem="selectItem" />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>

    <ModalFormPresupuestoGestionMes ref="modalFormPresupuestoGestionMesRef" :tipo="tipo" @actualizarListado="listar" />
  </v-dialog>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import ListadoPresupuestoGestion from '../views/ListadoPresupuestoGestion.vue';
import ModalFormPresupuestoGestionMes from './ModalFormPresupuestoGestionMes.vue';
import PresupuestoGastoServices from '../services/index';
import { ESTADOS_DETALLE_TRANSACCION, ACCIONES_CRUD } from '../utils';
import { mapGetters } from 'vuex';

export default {
  name: 'ModalPresupuestoGestion',
  components: {
    ListadoPresupuestoGestion,
    ModalFormPresupuestoGestionMes,
  },
  data() {
    return {
      cargando: false,
      items: [],
      item: null,
      visible: false,
      gestion: null,
      sede_id: null,
      presupuesto: null,
      deshabilitadoBotonVerificar: true,
      deshabilitadoBotonEditar: true,
      tipo: '',
      accionesPresupuestoGestion: ACCIONES_CRUD,
    };
  },
  computed: {
    permisoEnSede() {
      return this.$store.state.CARGO.sede.id == this.sede_id;
    },
    ...mapGetters({
      permisosPresupuestos1: 'presupuesto/permisosPresupuestos1',
      permisosPresupuestos2: 'presupuesto/permisosPresupuestos2',
      permisosPresupuestos3: 'presupuesto/permisosPresupuestos3',
    }),
  },
  methods: {
    abrir(presupuesto, tipo) {
      this.visible = true;
      this.presupuesto = presupuesto;
      this.tipo = tipo;
      this.listar();
    },
    cerrar() {
      this.$emit('cerrar');
      this.visible = false;
      this.presupuesto = null;
    },
    async listar() {
      const params = {
        tipo: this.tipo,
      };

      this.items = [];
      this.cargando = true;

      try {
        const { data } = await PresupuestoGastoServices.show(this.presupuesto.id, { params });
        const { datos } = data;
        const { gestion, sede_id, transacciones } = datos;

        this.gestion = gestion;
        this.sede_id = sede_id;
        this.items = transacciones;
        this.item = null;
        this.deshabilitadoBotonVerificar = true;
        this.deshabilitadoBotonEditar = true;
      } catch (error) {
        const { mensaje } = error?.response?.data;

        window.console.log(error);

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Error al listar',
          type: 'error',
        });
      } finally {
        this.cargando = false;
      }
    },
    selectItem(item) {
      this.item = item;

      const tieneDetallesTransacciones = item?.detalles_transacciones?.length > 0;
      const todosDetallesTransaccionesAceptados = item.detalles_transacciones.every(
        (detalle) => detalle.estado == ESTADOS_DETALLE_TRANSACCION.ACEPTADO,
      );
      const deshabilitarBoton = tieneDetallesTransacciones
        ? todosDetallesTransaccionesAceptados
          ? true
          : false
        : true;

      this.deshabilitadoBotonEditar = deshabilitarBoton;
      this.deshabilitadoBotonVerificar = deshabilitarBoton;
    },
  },
};
</script>